module.exports = __webpack_public_path__ + "img/service.8185d700.jpg";